import { AuthHeader } from '../_models/headers';


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';

@Injectable({
  providedIn: 'root'
})
export class TopicService {
  aHeader = undefined



  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService) {this.aHeader = new AuthHeader(tss) }
    getTopicById(topicId:number){
      return this.http.get<any>(`${environment.apiUrl}/topic/apishow/${topicId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            return this.dataUtilService.myData(x)
           }else{
            return {}
          }
        }
      ))
    }

    getTopicsByLevelId(levelId:number){
      return this.http.get<any>(`${environment.apiUrl}/topic/apitopicsbylevel/${levelId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            return this.dataUtilService.myData(x)
           }else{
            return {}
          }
        }
      ))
    }
    getTopicsIdAndNameByLevelId(levelId:number){
      return this.http.get<any>(`${environment.apiUrl}/topic/topicsIdAndNameByLevel/${levelId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            return this.dataUtilService.myData(x)
           }else{
            return {}
          }
        }
      ))
    }

    deleteSubTopicById(subTopicId:number){
      return this.http.get<any>(`${environment.apiUrl}/subTopic/deleteItem/${subTopicId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            return this.dataUtilService.myData(x)
           }else{
            return {}
          }
        }
      ))
    }
    addTopic(formData:string){
      return this.http.post(`${environment.apiUrl}/syllabus/addTopic`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){

            return this.dataUtilService.myData(data)
          }else{
            return {}
          }

        }));
    }
    editTopic(formData:string){
      return this.http.post(`${environment.apiUrl}/syllabus/editTopic`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }else{
            return {}
          }

        }));
    }

    deleteTopic(topicId:number){
      return this.http.get<any>(`${environment.apiUrl}/topic/apidelete/${topicId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            return this.dataUtilService.myData(x)
           }else{
            return {}
          }
        }
      ))
    }

}
